import { Badge, Flex } from 'antd';

import { useTeacherPendingMessages } from '@/store';
import { formatBadgeCount } from '@/utils';

export const PendingMessagesBadge = () => {
  const { pendingMessages, isLoading } = useTeacherPendingMessages();

  if (isLoading) return null;

  const displayCount = formatBadgeCount(pendingMessages);
  if (!displayCount) return null;

  return (
    <Flex align="center" justify="center">
      <Badge count={displayCount} />
    </Flex>
  );
};
